import { createWithEqualityFn } from 'zustand/traditional'
import { devtools, persist } from 'zustand/middleware'
import { shallow } from 'zustand/vanilla/shallow'

import { type State, initialState } from './initialState'

interface Action {
  updateState: <K extends keyof State>(key: K, value: State[K]) => void
  updateStates: (updates: Partial<State>) => void
}

export type Store = State & Action

// 使用zustand做状态管理
export const useAiMusicLibraryStore = createWithEqualityFn<Store>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        // 原子类型
        updateState: (key, value) =>
          set(
            (state) => ({
              ...state,
              [key]: value,
            }),
            false,
            `updateState-${key}`,
          ),
        // 批量更新函数
        updateStates: (updates) =>
          set((state) => ({
            ...state,
            ...updates,
          })),
      }),
      { name: 'AIMusicLibraryStore' },
    ),
    { name: 'AIMusicLibraryStore' },
  ),
  shallow,
)
